import { components } from 'react-select';

import ClearbitIcon from './Clearbit.svg';
import styles from './styles';

const MenuHeader = withStyles(styles, {})(
  ({ classes, selectProps: { menuListTitle, menuListIcon } }) => (
    <div className={classes.titleContainer}>
      <div className={classes.menuListIconContainer}>
        {menuListIcon ? menuListIcon : <ClearbitIcon />}
      </div>
      <span className={classes.sectionTitle}>{menuListTitle}</span>
    </div>
  ),
);

export default class Menu extends React.Component {
  render() {
    return (
      <components.Menu {...this.props}>
        <MenuHeader selectProps={this.props.selectProps} />
        {this.props.children}
      </components.Menu>
    );
  }
}

Menu.propTypes = {
  selectProps: PropTypes.object,
  children: PropTypes.node,
};
